module.exports = __webpack_public_path__ + "static/media/oitopositive.8fda5bf5.svg";